import React, { useState, useEffect } from "react";
import styles from "./Navbar.module.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const toggle = (name) => {
    setActive(active === name ? null : name);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setActive(null);
  };

  return (
    <header
      className={`${styles.navbar} ${
        scrolled ? styles.scrolled : styles.main
      }`}
    >
      <div className={styles.container}>

        {/* LOGO */}
        <a href="/" className={styles.brand} onClick={closeMenu}>
          <span>Happy Horizon</span>
        </a>

        {/* NAV */}
        <nav className={`${styles.nav} ${menuOpen ? styles.open : ""}`}>
          <a href="/" onClick={closeMenu}>Home</a>

          {/* CLASSES */}
          <div className={styles.dropdown}>
            <button onClick={() => toggle("classes")}>
              Classes
              <Arrow open={active === "classes"} />
            </button>

            {active === "classes" && (
              <div className={styles.menu}>
                <a href="/classes" onClick={closeMenu}>Art & Craft</a>
                <a href="/classes" onClick={closeMenu}>Dance</a>
                <a href="/classes" onClick={closeMenu}>Shloka Chanting</a>
                <a href="/classes" onClick={closeMenu}>Bricks4Kids</a>
                <a href="/classes" onClick={closeMenu}>Chess</a>
              </div>
            )}
          </div>

          <a href="/events" onClick={closeMenu}>Birthday & Events</a>
          <a href="/about" onClick={closeMenu}>About</a>
          <a href="/contact" onClick={closeMenu}>Contact</a>
        </nav>

        {/* HAMBURGER */}
        <button
          className={`${styles.hamburger} ${menuOpen ? styles.active : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </button>

      </div>
    </header>
  );
}

function Arrow({ open }) {
  return (
    <svg
      className={`${styles.arrow} ${open ? styles.rotate : ""}`}
      viewBox="0 0 24 24"
    >
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}
